import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["href", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useDeviceInfoQuery } from "@/hooks";
import config from "@/lib/config";
import maybeIOS from "@/lib/maybeIOS";
import styles from "@/styles/Link.module.scss";
import Link from "next/link";
import { useRouter } from "next/router";
import { useCallback, useMemo } from "react";
/**
 * WebView時にdeeplinkに書き換えるページをここで指定する。webのpath: アプリのpath
 * @type {Object.<string, string>}
 */

/**
 *WebViewで表示時、受け取ったhrefがpathsDictionaryにマッチした場合、deeplinkに書き換える。deeplinkの書き換えはページ名/[id]の形式のページに対してのみ動作する。(このコンポーネントをラップした要素の中にボタンがある場合、必ずそのボタンのコールバックでstopPropagationを呼び出すこと。)
 *@param {Object} props
 *@param {String} props.href - ページのpath
 *@param {React.element} props.children - このコンポーネントで括った親コンポーネントのDOM
 *@param {Object} ...props - その他props
 *@returns {React.element}
 */
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function VersatileLink(_ref) {
  let {
      href,
      children
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const {
    data: {
      deviceInfo
    } = {}
  } = useDeviceInfoQuery();
  const router = useRouter();
  const judgedLink = useMemo(() => {
    const {
      isWebView,
      isAndroid
    } = deviceInfo !== null && deviceInfo !== void 0 ? deviceInfo : {};
    const isIOS = maybeIOS(deviceInfo);
    const regex = new RegExp(`^/?(?<path>watch|title)/(?<id>\\d+)`);
    const matched = href.match(regex);
    if (matched && isWebView) {
      const {
        id
      } = matched.groups;
      if (isIOS) {
        return `spooxnew://works/${id}`;
      }
      if (isAndroid) {
        return `intent://works/${id}#Intent;scheme=spooxnew;package=${config.androidNewPackageName};end`;
      }
    } else {
      return href;
    }
  }, [deviceInfo, href]);
  const isWatchPageFlag = router.asPath.includes("/watch") && href.includes("/watch") && !judgedLink.includes("spoox://") && !judgedLink.includes("intent://") || false;

  // watchページからwatchページへの遷移時は状態をリセット
  const handleWatchPageClick = useCallback(() => {
    window.location.replace(judgedLink);
  }, [judgedLink]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [!isWatchPageFlag && /*#__PURE__*/_jsx(Link, _objectSpread(_objectSpread({}, props), {}, {
      href: judgedLink,
      legacyBehavior: true,
      children: children
    })), isWatchPageFlag && /*#__PURE__*/_jsx("div", {
      className: styles.watchLink,
      onClick: handleWatchPageClick,
      role: "link",
      tabIndex: "0",
      children: children
    })]
  });
}
export default VersatileLink;